export const LOGIN = "/";
export const DASHBOARD = "/dashboard";
export const AI_DECISION_MAKER = "/aidecisionmakers";
export const AI_LEADS = "/aileads";
export const AI_PATH = "/aipath";
export const AI_PROFILE = "/aiprofile/:tab";
export const AI_PROFILE_FORM_TABLE = "/aiprofileformtable";
export const AI_PROSPECT_PROFILE = "/aiprospectprofile";
export const COMPANY_PROFILE_SCREEN = "/companyprofilescreen/:id/:tab";
export const COMING_SOON = "/comingSoon";
export const LOGIN_CALLBACK = "/login/callback";
export const PDF_SAMPLE = "/pdfSample";
export const DATA_ENRICH = "/dataenrich";
export const TRACKING = "/tracking";
export const ARCHIVED = "/archived";
export const FAVORITES = "/favorites";
export const FAVORITES_LIST = "/favoritesList";
export const PROFILE = "/Profile/:id";
export const ERROR_SCREEN = "/ErrorScreen";
export const MAINTENANCE = "/maintainance";
export const PROSPECT_SEARCH_RESULTS = "/people-results";
export const ORGANIZATION_SEARCH_RESULTS = "/organization-results";
export const ORBIT_INTEL_CHAT = "/orbit-intel-chat";